import React from "react";
import {
    alpha,
    ButtonBase,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import { FONTS, CARD_STYLES } from "../../../constants/styles";

interface AddEventModalProps {
    open: boolean;
    onClose: () => void;
    onService: () => void;
    onPrivate: () => void;
}

const AddEventModal: React.FC<AddEventModalProps> = ({
    open,
    onClose,
    onService,
    onPrivate,
}) => {
    const theme = useTheme();
    const hex = theme.palette.primary.main;

    return (
        <Dialog
            className="force-dynamic-translation"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: "20px",
                    padding: 3,
                    textAlign: "center",
                    width: "min(520px, 92vw)",
                },
            }}
        >
            <DialogTitle sx={{ pb: 1 }}>
                <Typography
                    fontFamily={FONTS.display}
                    fontWeight={700}
                    fontSize="18px"
                >
                    Add event
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Stack spacing={1.5} mt={1}>
                    {/* Service appointment — solid card */}
                    <ButtonBase
                        onClick={onService}
                        sx={{
                            width: "100%",
                            borderRadius: CARD_STYLES.borderRadius,
                            textAlign: "left",
                        }}
                    >
                        <Stack
                            width="100%"
                            sx={{ ...CARD_STYLES }}
                            spacing={0.5}
                            alignItems="flex-start"
                        >
                            <Typography
                                fontFamily={FONTS.display}
                                fontWeight={600}
                                fontSize="15px"
                            >
                                Service appointment
                            </Typography>
                            <Typography fontSize="13px" color="text.secondary">
                                Book a client into this time
                            </Typography>
                        </Stack>
                    </ButtonBase>

                    {/* Private matter — dashed card */}
                    <ButtonBase
                        onClick={onPrivate}
                        sx={{
                            width: "100%",
                            borderRadius: CARD_STYLES.borderRadius,
                            textAlign: "left",
                        }}
                    >
                        <Stack
                            width="100%"
                            sx={{
                                ...CARD_STYLES,
                                bgcolor: alpha(hex, 0.04),
                                border: `1.5px dashed ${alpha(hex, 0.2)}`,
                            }}
                            spacing={0.5}
                            alignItems="flex-start"
                        >
                            <Typography
                                fontFamily={FONTS.display}
                                fontWeight={600}
                                fontSize="15px"
                            >
                                Private matter
                            </Typography>
                            <Typography fontSize="13px" color="text.secondary">
                                Block this time for yourself
                            </Typography>
                        </Stack>
                    </ButtonBase>
                </Stack>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", pt: 0 }}>
                <ButtonBase
                    onClick={onClose}
                    sx={{
                        borderRadius: 20,
                        px: 2,
                        py: 0.75,
                        bgcolor: "rgba(0,0,0,0.04)",
                    }}
                >
                    <Typography
                        fontFamily={FONTS.display}
                        fontSize="13px"
                        fontWeight={600}
                        color="text.secondary"
                    >
                        Cancel
                    </Typography>
                </ButtonBase>
            </DialogActions>
        </Dialog>
    );
};

export default AddEventModal;
